import { Button, FormControlLabel, Grid, MenuItem, Radio, RadioGroup, Typography } from "@material-ui/core";
import { SaveOutlined } from "@material-ui/icons";
import { Field, useFormikContext } from "formik";
import { Checkbox, TextField } from 'formik-material-ui';
import { ReferenceData } from "helpers/enums";
import { applicationContext } from "helpers/services";
import { useContext } from "react";
import * as yup from "yup";
import { userContext, userSchema } from "../UserContext";


let UserForm = () => {
    let { isNew } = useContext(userContext);
    let { userGroups, ticketTypes, referenceData } = useContext(applicationContext)

    type User = yup.InferType<typeof userSchema>
    let form = useFormikContext<User>();


    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        name="email"
                        type="email"
                        disabled={isNew === false}
                        label="Email"
                        variant="outlined"
                        fullWidth
                        onBlur={() => {
                            // Se sto inserendo un nuovo utente
                            if (isNew === true) {
                                // se è un utente manfrotto con email esterna 
                                let isExternalManfrottoUser = form.values.email.toLowerCase().indexOf('@videndum.com') === -1;

                                // setto che può lavorare solo per ticket del suo gruppo
                                if (isExternalManfrottoUser) {
                                    form.setFieldValue('canWorkOnTicketAssignedToMyGroup', true);

                                    // Se precedentemente c'era il flag canWorkOnAllTickets a true lo metto a false
                                    if (form.values.canWorkOnAllTicket === true)
                                        form.setFieldValue('canWorkOnAllTicket', false);
                                }
                            }
                        }}
                    />
                </Grid>
                {form.values.email?.includes("@manfrotto") === false &&
                    <>
                        <Grid item xs={6}>
                            <Field
                                component={TextField}
                                name="firstName"
                                label="First Name"
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Field
                                component={TextField}
                                name="lastName"
                                label="Last Name"
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                    </>
                }
                <Grid item xs={12}>
                    <Field
                        component={TextField}
                        select
                        label="Supplier"
                        name="defaultSupplier"
                        variant="outlined"
                        size="small"
                        fullWidth
                    >
                        <MenuItem value=''>Not set</MenuItem>
                        {referenceData.getByKey(ReferenceData.Supplier)?.values.map(x => <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>)}
                    </Field>
                </Grid>
                <Grid item xs={12}>
                    <Field
                        name="groups"
                        component={TextField}
                        select
                        SelectProps={{ multiple: true }}
                        fullWidth
                        variant="outlined"
                        label="Group"
                    >
                        {userGroups.map(x => <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>)}
                    </Field>
                </Grid>

                <Grid container>
                    <Grid item xs={6}>
                        <Field
                            component={TextField}
                            name="m3Id"
                            label="M3 Id"
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Field
                            component={TextField}
                            name="companyName"
                            label="Company Name"
                            variant="outlined"
                            fullWidth
                        />
                    </Grid>
                </Grid>

                <Grid item xs={12} md={12}>
                    <Typography variant="body2"><b>Ticket Permissions</b></Typography>
                    <Grid container>
                        <Grid item xs={12}>
                            <RadioGroup
                                row
                                value={form.values.canWorkOnAllTicket === true
                                    ? "canWorkOnAllTicket"
                                    : (form.values.canViewTickets === true ? "canViewTickets" : "canWorkOnTicketAssignedToMyGroup")
                                }
                                onChange={(e, value) => {
                                    form.setFieldValue('canWorkOnAllTicket', value == "canWorkOnAllTicket")
                                    form.setFieldValue('canWorkOnTicketAssignedToMyGroup', value == "canWorkOnTicketAssignedToMyGroup")
                                    form.setFieldValue('canViewTickets', value == "canViewTickets")
                                }}
                            >
                                <FormControlLabel value={"canViewTickets"} control={<Radio />} label="Can view all tickets" />
                                <FormControlLabel value={"canWorkOnTicketAssignedToMyGroup"} control={<Radio />} label="Can work on tickets assigned to my group" />
                                <FormControlLabel disabled={form.values.email.toLowerCase().indexOf('@videndum.com') === -1} value={"canWorkOnAllTicket"} control={<Radio />} label="Can work on all tickets" />
                            </RadioGroup>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                label="Can manage ticket settings"
                                name="canManageTicketSettings"
                                value={form.values.canManageTicketSettings}
                                checked={form.values.canManageTicketSettings}
                                onChange={(e: any) => form.setFieldValue('canManageTicketSettings', e.target.checked)}
                                control={<Field type="checkbox" name="canManageTicketSettings" component={Checkbox} />}
                            />
                        </Grid>
                        <Grid item>
                            <FormControlLabel
                                label="Can create tickets"
                                name="canCreateTickets"
                                value={form.values.canCreateTickets}
                                checked={form.values.canCreateTickets}
                                onChange={(e: any) => form.setFieldValue('canCreateTickets', e.target.checked)}
                                control={<Field type="checkbox" name="canCreateTickets" component={Checkbox} />}
                            />
                        </Grid>
                        <Grid item>
                            <FormControlLabel
                                label="Can delete tickets"
                                name="canDeleteTickets"
                                value={form.values.canDeleteTickets}
                                checked={form.values.canDeleteTickets}
                                onChange={(e: any) => form.setFieldValue('canDeleteTickets', e.target.checked)}
                                control={<Field type="checkbox" name="canDeleteTickets" component={Checkbox} />}
                            />
                        </Grid>

                        <Grid item>
                            <FormControlLabel
                                label="Can do bulk edit"
                                name="canDoBulkEdit"
                                value={form.values.canDoBulkEdit}
                                checked={form.values.canDoBulkEdit}
                                onChange={(e: any) => form.setFieldValue('canDoBulkEdit', e.target.checked)}
                                control={<Field type="checkbox" name="canDoBulkEdit" component={Checkbox} />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                label="Can reply to customers"
                                name="canReplyToCustomer"
                                value={form.values.canReplyToCustomer}
                                checked={form.values.canReplyToCustomer}
                                onChange={(e: any) => form.setFieldValue('canReplyToCustomer', e.target.checked)}
                                control={<Field type="checkbox" name="canReplyToCustomer" component={Checkbox} />}
                            />
                        </Grid>


                        <Grid item xs={12}>
                            <FormControlLabel
                                label="Can create Excel ticket export"
                                name="canCreateExcelTicketExport"
                                value={form.values.canCreateExcelTicketExport}
                                checked={form.values.canCreateExcelTicketExport}
                                onChange={(e: any) => form.setFieldValue('canCreateExcelTicketExport', e.target.checked)}
                                control={<Field type="checkbox" name="canCreateExcelTicketExport" component={Checkbox} />}
                            />
                        </Grid>

                    </Grid>
                </Grid>

                <Grid item xs={12} md={12}>
                    <Typography variant="body2"><b>Users management</b></Typography>
                    <Grid container>
                        <Grid item>
                            <FormControlLabel
                                label="Can Manage Videndum Users"
                                name="canManageVitecUsers"
                                value={form.values.canManageVitecUsers}
                                checked={form.values.canManageVitecUsers}
                                onChange={(e: any) => form.setFieldValue('canManageVitecUsers', e.target.checked)}
                                control={<Field type="checkbox" name="canManageVitecUsers" component={Checkbox} />}
                            />
                        </Grid>
                        <Grid item>
                            <FormControlLabel
                                label="Can Manage Customer Users"
                                name="canManageCustomerUsers"
                                value={form.values.canManageCustomerUsers}
                                checked={form.values.canManageCustomerUsers}
                                onChange={(e: any) => form.setFieldValue('canManageCustomerUsers', e.target.checked)}
                                control={<Field type="checkbox" name="canManageCustomerUsers" component={Checkbox} />}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs md={12}>
                    <Typography variant="body2"><b>New ticket notifications</b></Typography>
                    <Grid container>
                        <Grid item xs>
                            <FormControlLabel
                                label="Receive new ticket notifications"
                                name="receiveNewTicketNotifications"
                                value={form.values.receiveNewTicketNotifications}
                                checked={form.values.receiveNewTicketNotifications}
                                onChange={(e: any) => {
                                    form.setFieldValue('receiveNewTicketNotifications', e.target.checked)

                                    form.setFieldValue('receiveNewTicketNotificationsType', 'all');
                                    form.setFieldValue("newTicketNotificationsTicketTypes", []);
                                }}
                                control={<Field type="checkbox" name="receiveNewTicketNotifications" component={Checkbox} />}
                            />
                        </Grid>
                        {form.values.receiveNewTicketNotifications === true &&
                            <>
                                <Grid item xs={12}>
                                    <RadioGroup
                                        row
                                        value={form.values.receiveNewTicketNotificationsType}
                                        onChange={(e) => form.setFieldValue('receiveNewTicketNotificationsType', e.target.value)}
                                    >
                                        <FormControlLabel value='all' control={<Radio />} label="All new ticket notifications" />
                                        <FormControlLabel value='bytype' control={<Radio />} label="Only some ticket type notifications" />
                                    </RadioGroup>
                                </Grid>

                                {form.values.receiveNewTicketNotificationsType === 'bytype' &&
                                    <Grid item xs md={12}>
                                        <Field
                                            component={TextField}
                                            name="newTicketNotificationsTicketTypes"
                                            label="Ticket types"
                                            variant="outlined"
                                            select
                                            fullWidth
                                            SelectProps={{ multiple: true }}
                                        >
                                            {ticketTypes.map((type, index) =>
                                                <MenuItem key={index} value={type.id}>{type.name}</MenuItem>
                                            )}
                                        </Field>
                                    </Grid>
                                }
                            </>
                        }
                    </Grid>

                    <Typography variant="body2"><b>Other ticket notifications</b></Typography>
                    <Grid container>
                        <Grid item>
                            <FormControlLabel
                                label="Notify me when I am assigned to a ticket"
                                name="notifyWhenImAssigned"
                                value={form.values.notifyWhenImAssigned}
                                checked={form.values.notifyWhenImAssigned}
                                onChange={(e: any) => form.setFieldValue('notifyWhenImAssigned', e.target.checked)}
                                control={<Field type="checkbox" name="notifyWhenImAssigned" component={Checkbox} />}
                            />
                        </Grid>
                        <Grid item>
                            <FormControlLabel
                                label="Notify me when a resolutions is updated"
                                name="notifyResolutionsUpdate"
                                value={form.values.notifyResolutionsUpdate}
                                checked={form.values.notifyResolutionsUpdate}
                                onChange={(e: any) => form.setFieldValue('notifyResolutionsUpdate', e.target.checked)}
                                control={<Field type="checkbox" name="notifyResolutionsUpdate" component={Checkbox} />}
                            />
                        </Grid>
                        <Grid item>
                            <FormControlLabel
                                label="Notify me when my group is added to group list"
                                name="notifiyWhenMyGroupIsAdded"
                                value={form.values.notifiyWhenMyGroupIsAdded}
                                checked={form.values.notifiyWhenMyGroupIsAdded}
                                onChange={(e: any) => form.setFieldValue('notifiyWhenMyGroupIsAdded', e.target.checked)}
                                control={<Field type="checkbox" name="notifiyWhenMyGroupIsAdded" component={Checkbox} />}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} md={12}>
                    <Typography variant="body2"><b>Reference Data</b></Typography>
                    <Grid container>
                        <Grid item>
                            <FormControlLabel
                                label="Claims platform admin"
                                name="claimsPlatformAdmin"
                                value={form.values.claimsPlatformAdmin}
                                checked={form.values.claimsPlatformAdmin}
                                onChange={(e: any) => form.setFieldValue('claimsPlatformAdmin', e.target.checked)}
                                control={<Field type="checkbox" name="claimsPlatformAdmin" component={Checkbox} />}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs />
                <Grid item>
                    <Button type="submit" color="secondary" variant="contained">
                        <SaveOutlined />&nbsp;Save
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}

export default UserForm;